(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
// Article tables ship as bare <table> inside article.content, so the scroll
// container has to be added client-side. Idempotent: safe if the section
// re-renders in the theme editor.
(function () {
  function enhance(root) {
    (root || document).querySelectorAll('.main-article__content table').forEach(function (table) {
      // Count the widest row. A 2 or 3 column table does not need a scroll
      // container, and forcing one on a small table nested inside one of the
      // article's own cards produces a scrollbar where there was room to spare.
      var cols = 0;
      table.querySelectorAll('tr').forEach(function (tr) {
        var n = 0;
        tr.querySelectorAll('th, td').forEach(function (c) { n += (c.colSpan || 1); });
        if (n > cols) cols = n;
      });
      var narrow = cols > 0 && cols <= 3;

      var wrap = table.parentElement;
      if (!wrap || !wrap.classList.contains('article-table-wrap')) {
        wrap = document.createElement('div');
        wrap.className = 'article-table-wrap' + (narrow ? ' article-table-wrap--narrow' : '');
        wrap.setAttribute('tabindex', '0');
        wrap.setAttribute('role', 'region');
        wrap.setAttribute('aria-label', 'Table, scroll horizontally to see more');
        table.parentNode.insertBefore(wrap, table);
        wrap.appendChild(table);
      }
      var update = function () {
        var scrollable = wrap.scrollWidth > wrap.clientWidth + 1;
        wrap.classList.toggle('is-scrollable', scrollable);
        wrap.classList.toggle(
          'is-scrolled-end',
          scrollable && wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 2
        );
      };
      update();
      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
    });
  }
  // Build the right-nav table of contents from the article's own h2/h3.
  function buildToc() {
    var nav = document.querySelector('[data-article-toc]');
    var list = document.querySelector('[data-article-toc-list]');
    var content = document.querySelector('.main-article__content');
    if (!nav || !list || !content) return;

    var heads = content.querySelectorAll('h2, h3');
    var items = [];
    var used = {};
    heads.forEach(function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      if (!h.id) {
        var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
        used[base] = (used[base] || 0) + 1;
        h.id = used[base] > 1 ? base + '-' + used[base] : base;
      }
      items.push(h);
    });
    // A two-entry contents list is noise. Only show it when it earns its place.
    if (items.length < 3) return;

    items.forEach(function (h) {
      var li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'article-toc__sub';
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = (h.textContent || '').trim();
      li.appendChild(a);
      list.appendChild(li);
    });
    nav.hidden = false;

    if (!('IntersectionObserver' in window)) return;
    var links = {};
    list.querySelectorAll('a').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var seen = new Set();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) seen.add(e.target.id); else seen.delete(e.target.id);
      });
      var currentId = items.map(function (h) { return h.id; }).filter(function (id) { return seen.has(id); })[0];
      Object.keys(links).forEach(function (id) { links[id].classList.toggle('is-current', id === currentId); });
    }, { rootMargin: '-10% 0px -70% 0px' });
    items.forEach(function (h) { obs.observe(h); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhance(); buildToc(); });
  } else {
    enhance();
    buildToc();
  }
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
